import Types from '../../../actions/Types'
import AppConstants from '../../../utils/AppConstants'

const initialState = AppConstants.PAGE.PRODUCTS_VIEW

export default (state = initialState, action = null) => {
  switch (action.type) {
    case Types.AUTH.LOGIN.SUCCESS:
      return initialState
    case Types.APP.CHANGEPAGE:
      return action.page
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/root/app/page.js